/* ---------- menu, living ink ----------
   thirty-two stills replayed on a canvas behind the mark: opening walks the
   sequence forward, closing walks it back out, held open the last frames breathe */
  function wireMenuSeq() {
    const mo = document.getElementById('menu-overlay');
    if (!mo) return;

    const N = 32, DIR = asset('shared/assets/brand/ink-seq-b2/');
    const TUNE = { open: 1300, veil: 100, zoom: 1.06,
      ease: function (u) { const o = 1 - (1 - u) * (1 - u); return 0.75 * o + 0.25 * u; } };
    const SHUT_MS = 700, VEIL_OUT_MS = 200;
    const IDLE_SPAN = 6, IDLE_MS = 8000;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let frames = [], armed = false, dead = false, left = N;
    const canvas = document.createElement('canvas');
    canvas.className = 'mn-seq';
    const ctx = canvas.getContext('2d');
    let mode = null, raf = null, t0 = 0, pos = 0, shutFrom = 0;
    let lastPainted = -1, lastZoom = 1;

    function fit() {
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      const w = Math.round(mo.clientWidth * dpr), h = Math.round(mo.clientHeight * dpr);
      if (!w || !h || (canvas.width === w && canvas.height === h)) return;
      canvas.width = w; canvas.height = h;
      lastPainted = -1;
    }

    /* cover held at 50% 64%; the zoom scales about the same anchor, so the
       settle drifts nothing */
    function cover(img, z) {
      const s = Math.max(canvas.width / img.naturalWidth, canvas.height / img.naturalHeight) * z;
      const dw = img.naturalWidth * s, dh = img.naturalHeight * s;
      ctx.drawImage(img, (canvas.width - dw) * 0.5, (canvas.height - dh) * 0.64, dw, dh);
    }

    /* a crossfade between frames, so the pour reads continuous */
    function paint(at, z) {
      at = Math.max(0, Math.min(N - 1, at));
      if (Math.abs(at - lastPainted) < 1 / 64 && Math.abs(z - lastZoom) < 0.001) return;
      lastPainted = at; lastZoom = z;
      const i = Math.floor(at), f = at - i;
      cover(frames[i], z);
      if (f > 0.004 && i < N - 1) {
        ctx.globalAlpha = f;
        cover(frames[i + 1], z);
        ctx.globalAlpha = 1;
      }
    }

    function stop() { if (raf) cancelAnimationFrame(raf); raf = null; mode = null; }

    function settle() {
      fit();
      pos = N - 1;
      paint(pos, 1);
      canvas.style.opacity = 1;
      idle();
    }

    /* the last few frames walked back and forth too slowly to read as a loop */
    function idle() {
      if (reduce) return;
      mode = 'idle'; t0 = performance.now();
      raf = requestAnimationFrame(tick);
    }

    function tick(now) {
      if (mo.hidden) { stop(); return; }
      const t = now - t0;
      if (mode === 'in') {
        const u = Math.min(1, t / TUNE.open);
        /* the pour opens at the footage's own pace; only the landing is eased */
        const e = TUNE.ease(u);
        pos = e * (N - 1);
        paint(pos, 1 + (TUNE.zoom - 1) * (1 - e));
        canvas.style.opacity = Math.min(1, t / TUNE.veil);
        if (t >= TUNE.open) { idle(); return; }
      } else if (mode === 'out') {
        const v = Math.min(1, t / SHUT_MS);
        /* the last stretch veils out: frame 0 still carries ink, and a hard cut
           reads as the texture jumping */
        const w = 0.75 * v * v + 0.25 * v;
        pos = shutFrom * (1 - w);
        paint(pos, 1);
        canvas.style.opacity = Math.min(1, (1 - v) * SHUT_MS / VEIL_OUT_MS);
        if (v >= 1) {
          canvas.style.opacity = 0;
          stop();
          /* the door hears this and only now closes (assets/menu.js shut) */
          mo.dispatchEvent(new CustomEvent('menu:shut-done'));
          mo.classList.remove('mn-shutting');
          return;
        }
      } else if (mode === 'idle') {
        const p = (t % IDLE_MS) / IDLE_MS * 2;
        pos = N - 1 - IDLE_SPAN * (p < 1 ? p : 2 - p);
        paint(pos, 1);
      }
      raf = requestAnimationFrame(tick);
    }

    mo.addEventListener('menu:open', function (e) {
      if (!armed) return;
      stop();
      fit();
      mo.classList.remove('mn-shutting');
      if (e.detail && e.detail.instant || reduce) { settle(); return; }
      pos = 0; lastPainted = -1;
      canvas.style.opacity = 0;
      mode = 'in'; t0 = performance.now();
      raf = requestAnimationFrame(tick);
    });

    mo.addEventListener('menu:shut', function () {
      if (!armed) return;
      stop();
      if (reduce) { canvas.style.opacity = 0; return; }
      shutFrom = pos; lastPainted = -1;
      /* the pour stands at full ink for its whole walk back out */
      canvas.style.opacity = 1;
      mo.classList.add('mn-shutting');
      mode = 'out'; t0 = performance.now();
      raf = requestAnimationFrame(tick);
    });

    window.addEventListener('resize', function () {
      if (!armed || mo.hidden) return;
      fit();
      paint(pos, 1);
    });

    /* whole or not at all: a single miss stands the whole variant down */
    function one() {
      if (--left || dead) return;
      armed = true;
      mo.insertBefore(canvas, mo.firstChild);
      document.body.dataset.seq = '1';
      if (!mo.hidden) settle();
    }
    function miss() {
      dead = true;
      if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
    }
    /* the set is three megabytes and the door may never be opened: fetched when
       the reader reaches for it; until then the still wash keeps the door */
    let asked = false;
    function fetchFrames() {
      if (asked || dead) return;
      /* not on the phone, where drawer.js takes the corner and this door never
         opens; read here rather than at wire time so it answers for the window
         the tap happened in */
      if (typeof isPhone === 'function' && isPhone()) return;
      asked = true;
      for (let i = 0; i < N; i++) {
        const img = new Image();
        img.onload = one;
        img.onerror = miss;
        img.src = DIR + 'frame-' + String(i).padStart(2, '0') + '.jpg?v=2';
        frames.push(img);
      }
    }
    /* the corner only: a touch anywhere once bought three megabytes on the
       first flick of a scroll */
    const btn = document.getElementById('menu-btn');
    if (btn) {
      btn.addEventListener('pointerenter', fetchFrames, { once: true });
      btn.addEventListener('pointerdown', fetchFrames, { once: true });
    }
    /* ?menuopen asks outright (boot.js waits on the frames) */
    if (typeof param === 'function' && param('menuopen')) fetchFrames();
  }
